import { css } from 'linaria';
import { strictBreakpoints } from 'media';

export const optionsHeaderStyles = css`
	margin-top: 60px;
	margin-bottom: 32px;
	${strictBreakpoints.onlyDesktop} {
		margin-top: 80px;
	}
	${strictBreakpoints.onlyTablet} {
		margin-top: 80px;
	}
	${strictBreakpoints.onlyMobile} {
		margin-top: 40px;
		margin-bottom: 24px;
	}
`;
